(function () {
    "use strict";

    angular.module("iMatApp")
        .controller("ModelProcessingController", ModelProcessingController);

    ModelProcessingController.$inject = ["$scope", "modelTabWorkflow"];

    function ModelProcessingController($scope, modelTabWorkflow) {
        var vm = this;

        vm.abortProcess = modelTabWorkflow.abortAndResetState;
    }
})();